// src/models/Descuento.js
export class Descuento {
  constructor(data = {}) {
    console.log('🔍 Descuento constructor - data recibido:', data);
    console.log('🔍 Descuento constructor - keys disponibles:', Object.keys(data));
    
    // Normalizar las claves de entrada
    const normalizedData = this.normalizeKeys(data);
    
    // Mapeo de campos básicos
    this.Id_descuento = normalizedData.id_descuento || normalizedData.Id_descuento || 0;
    this.Nombre = normalizedData.nombre || normalizedData.Nombre || '';
    this.Descripcion = normalizedData.descripcion || normalizedData.Descripcion || '';
    //this.Tipo = normalizedData.tipo || normalizedData.Tipo || 'PORCENTAJE';
    this.Valor = normalizedData.valor || normalizedData.Valor || 0;
    this.Fecha_inicio = normalizedData.fecha_inicio || normalizedData.Fecha_inicio || '';
    this.Fecha_fin = normalizedData.fecha_fin || normalizedData.Fecha_fin || '';
    this.Estado = normalizedData.estado || normalizedData.Estado || 'ACTIVO';
    this.Id_sucursal = normalizedData.id_sucursal || normalizedData.Id_sucursal || 0;
    this.Limite_usos = normalizedData.limite_usos || normalizedData.Limite_usos || false;
    this.Cantidad_usos = normalizedData.cantidad_usos || normalizedData.Cantidad_usos || null;
    this.Usos_actuales = normalizedData.usos_actuales || normalizedData.Usos_actuales || 0;
    this.Fecha_creacion = normalizedData.fecha_creacion || normalizedData.Fecha_creacion || null;
    this.Hora_creacion = normalizedData.hora_creacion || normalizedData.Hora_creacion || null;
    
    // Campos de navegación
    this.Nombre_sucursal = normalizedData.nombre_sucursal || normalizedData.Nombre_sucursal || '';
    //this.Nombre_empresa = normalizedData.nombre_empresa || normalizedData.Nombre_empresa || '';
    
    // Lista de productos (puede venir como array de IDs o como objetos completos)
    this.ProductoIds = normalizedData.productoIds || normalizedData.ProductoIds || [];
    this.Productos = normalizedData.productos || normalizedData.Productos || [];
    
    console.log('🔍 Descuento constructor - objeto creado:', {
      Id_descuento: this.Id_descuento,
      Nombre: this.Nombre,
      //Tipo: this.Tipo,
      Valor: this.Valor,
      Estado: this.Estado,
      Productos: this.Productos.length
    });
  }

  normalizeKeys(data) {
    if (!data) return {};
    
    const normalized = {};
    for (const [key, value] of Object.entries(data)) {
      normalized[key.toLowerCase()] = value;
      normalized[key] = value;
    }
    return normalized;
  }

  // Validaciones
  isValid() {
    if (!this.Nombre.trim()) return { valid: false, message: 'El nombre es requerido' };
    if (this.Valor <= 0) return { valid: false, message: 'El valor debe ser mayor a 0' };
    // if (this.Tipo === 'PORCENTAJE' && (this.Valor < 1 || this.Valor > 100)) {
    //   return { valid: false, message: 'El porcentaje debe estar entre 1 y 100' };
    // }
    if (!this.Fecha_inicio) return { valid: false, message: 'La fecha de inicio es requerida' };
    if (!this.Fecha_fin) return { valid: false, message: 'La fecha de fin es requerida' };
    if (new Date(this.Fecha_fin) <= new Date(this.Fecha_inicio)) {
      return { valid: false, message: 'La fecha de fin debe ser posterior a la fecha de inicio' };
    }
    if (this.ProductoIds.length === 0 && this.Productos.length === 0) {
      return { valid: false, message: 'Debe seleccionar al menos un producto' };
    }
    if (this.Limite_usos && (!this.Cantidad_usos || this.Cantidad_usos <= 0)) {
      return { valid: false, message: 'Si activa límite de usos, debe especificar una cantidad válida' };
    }
    
    return { valid: true, message: '' };
  }

  // Verificar si está activo
  isActive() {
    if (this.Estado !== 'ACTIVO') return false;
    
    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);
    
    const inicio = new Date(this.Fecha_inicio);
    inicio.setHours(0, 0, 0, 0);
    
    const fin = new Date(this.Fecha_fin);
    fin.setHours(23, 59, 59, 999);
    
    return hoy >= inicio && hoy <= fin;
  }

  // Verificar si llegó al límite de usos
  hasReachedLimit() {
    if (!this.Limite_usos || !this.Cantidad_usos) return false;
    return this.Usos_actuales >= this.Cantidad_usos;
  }

  // Calcular precio con descuento
  calculateDiscountedPrice(precio) {
    // if (this.Tipo === 'PORCENTAJE') {
    //   return precio - (precio * this.Valor / 100);
    // }
    // return Math.max(0, precio - this.Valor);
  }

  // Obtener porcentaje de uso
  getUsagePercentage() {
    if (!this.Limite_usos || !this.Cantidad_usos) return 0;
    return Math.min((this.Usos_actuales / this.Cantidad_usos) * 100, 100);
  }

  // Obtener etiqueta del tipo
//   getTipoLabel() {
//     return this.Tipo === 'PORCENTAJE' ? `${this.Valor}%` : `${this.Valor.toFixed(2)}`;
//   }

  // Formatear fecha para mostrar
  formatDate(dateField) {
    const date = dateField === 'inicio' ? this.Fecha_inicio : this.Fecha_fin;
    if (!date) return '';
    
    const d = new Date(date);
    return d.toLocaleDateString('es-PE', { year: 'numeric', month: '2-digit', day: '2-digit' });
  }

  // Obtener datos para enviar al API (CREATE)
  toApiCreateFormat() {
    return {
      nombre: this.Nombre,
      descripcion: this.Descripcion || null,
      //tipo: this.Tipo,
      valor: parseFloat(this.Valor),
      fecha_inicio: this.Fecha_inicio,
      fecha_fin: this.Fecha_fin,
      estado: this.Estado,
      id_sucursal: this.Id_sucursal,
      limite_usos: this.Limite_usos,
      cantidad_usos: this.Limite_usos ? parseInt(this.Cantidad_usos) : null,
      productoIds: this.ProductoIds
    };
  }

  // Obtener datos para enviar al API (UPDATE)
  toApiUpdateFormat() {
    return {
      nombre: this.Nombre,
      descripcion: this.Descripcion || null,
      //tipo: this.Tipo,
      valor: parseFloat(this.Valor),
      fecha_inicio: this.Fecha_inicio.split('T')[0],
      fecha_fin: this.Fecha_fin.split('T')[0],
      estado: this.Estado,
      id_sucursal: this.Id_sucursal,
      limite_usos: this.Limite_usos,
      cantidad_usos: this.Limite_usos ? parseInt(this.Cantidad_usos) : null,
      productoIds: this.ProductoIds
    };
  }

  // Obtener IDs de productos
  getProductIds() {
    if (this.ProductoIds.length > 0) {
      return this.ProductoIds;
    }
    if (this.Productos.length > 0) {
      return this.Productos.map(p => {
        const normalized = this.normalizeKeys(p);
        return normalized.id_producto || normalized.Id_producto || 0;
      });
    }
    return [];
  }

  // Establecer productos desde array de IDs
  setProductIds(ids) {
    this.ProductoIds = Array.isArray(ids) ? ids : [];
  }

  // Para debug
  toDebug() {
    return {
      'Frontend (mayúsculas)': {
        Id_descuento: this.Id_descuento,
        Nombre: this.Nombre,
        //Tipo: this.Tipo,
        Valor: this.Valor,
        Estado: this.Estado,
        Fecha_inicio: this.Fecha_inicio,
        Fecha_fin: this.Fecha_fin,
        Limite_usos: this.Limite_usos,
        Cantidad_usos: this.Cantidad_usos,
        Usos_actuales: this.Usos_actuales,
        ProductoIds: this.ProductoIds.length,
        Productos: this.Productos.length
      },
      'Is Valid': this.isValid(),
      'Is Active': this.isActive(),
      'Has Reached Limit': this.hasReachedLimit(),
      'Usage Percentage': `${this.getUsagePercentage().toFixed(2)}%`
    };
  }
}
